export default{
    cadastra:{
        method:'post',
        url:'tomador/cadastro'
    },
    delete:{
        method:'delete',
        url:'tomador/deletar{/id}'
    },
    lista:{
        method:'get',
        url:'tomador/lista'
    },
    editar:{
        method:'get',
        url:'tomador/editar{/id}'
    },
    update:{
        method:'post',
        url:'tomador/update'
    },
    evento:{
        method:'post',
        url:'tomador/evento/cadastro'
    },
    eventolista:{
        method:'get',
        url:'tomador/evento/1020/lista{/id}'
    },
    eventocadastra:{
        method:'put',
        url:'evento/update'
    },
    eventodeleteesocial:{
        method:'delete',
        url:'tomador/evento/deletar{/id}'
    },
    eventodelete:{
        method:'delete',
        url:'tomador/evento/deletar{/id}'
    },
    eventoupdate:{
        method:'put',
        url:'tomador/evento/update'
    },
    documento:{
        method:'get',
        url:'documentos/tomador/lista?id={id}'
    },
    matricula:{
        method:'get',
        url:'tomador/matricula'
    },
    duplica:{
        method:'get',
        url:'tomador/duplica{/id}'
    },
    
}